export default __webpack_public_path__ + "static/media/santa.ef125a43.svg";